import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./ResponsiveImage.css";

// Import the lazyloading module if the window context is defined.
if (typeof window !== "undefined") {
  import("lazysizes");
}
// This creates a string to be passed into the'srcSet' attribute for the image:
const createSrcSetString = imageSizes => {
  return imageSizes.map(size => `${size.url} ${size.width}w`).join(", ");
};

const ResponsiveImage = ({
  isAnimated,
  src,
  videos,
  alt,
  lazyload,
  aspectRatio,
  images,
  sizes,
}) => {
  const paddingBottom = `${(1 / aspectRatio) * 100}%`;

  if (isAnimated && videos) {
    return (
      <div className={styles.root} style={{ paddingBottom }}>
        <video
          autoPlay
          loop
          muted
          playsInline
          data-testid="video-tag"
          className={styles.video}
        >
          <source src={videos.webm} type="video/webm" />
          <source src={videos.mp4} type="video/mp4" />
        </video>
      </div>
    );
  } else if (lazyload) {
    return (
      <div className={styles.root} style={{ paddingBottom }}>
        <img
          className={classNames(styles.image, "lazyload")}
          data-src={src}
          alt={alt}
          data-testid="lazyload-tag"
          srcSet={images && createSrcSetString(images)}
          sizes={sizes}
        />
      </div>
    );
  } else {
    return (
      <div className={styles.root} style={{ paddingBottom }}>
        <img
          className={styles.image}
          src={src}
          alt={alt}
          data-testid="regular-image-tag"
          srcSet={images && createSrcSetString(images)}
          sizes={sizes}
        />
      </div>
    );
  }
};

ResponsiveImage.defaultProps = {
  alt: "",
};

ResponsiveImage.propTypes = {
  isAnimated: PropTypes.bool,
  src: PropTypes.string.isRequired,
  videos: PropTypes.shape({
    webm: PropTypes.string,
    mp4: PropTypes.string,
  }),
  images: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  alt: PropTypes.string,
  aspectRatio: PropTypes.number.isRequired,
  lazyload: PropTypes.bool,
};

export default ResponsiveImage;
